export default function useLogin() {
  return () => {
    window.location.href = window.location.origin + "/account/";
  };
}
